import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../AppContext';

function CreateNexusForm({ onNexusCreated }) {
    const { t } = useTranslation();
    const { appFunctions, setMessage, showConfirmation } = useAppContext();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [privacy, setPrivacy] = useState('public');
    const [color, setColor] = useState('#6366f1');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const NEXUS_CREATION_COST = 500;

    const handleSubmit = async (e) => {
        e.preventDefault();
        showConfirmation({
            message: t('createNexus.confirmation', { cost: NEXUS_CREATION_COST }),
            onConfirm: async () => {
                setIsSubmitting(true);
                const createNexus = httpsCallable(appFunctions, 'createNexus');
                try {
                    await createNexus({ name, description, privacy, color });
                    setMessage(t('createNexus.success'));
                    onNexusCreated();
                } catch (error) {
                    setMessage(`${t('createNexus.failure')}: ${error.message}`);
                } finally {
                    setIsSubmitting(false);
                }
            }
        });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4 max-w-lg mx-auto animate-fadeIn">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t('createNexus.namePlaceholder')} className="w-full bg-gray-800 p-3 rounded-lg border border-gray-700 focus:ring-2 focus:ring-purple-500 outline-none" required />
            <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder={t('createNexus.descriptionPlaceholder')} className="w-full bg-gray-800 p-3 rounded-lg border border-gray-700 h-24 focus:ring-2 focus:ring-purple-500 outline-none" required />
            <div className="flex items-center justify-between bg-gray-800/50 p-3 rounded-lg">
                <label className="font-bold">{t('createNexus.privacyLabel')}:</label>
                <div className="flex gap-4">
                    <label className="flex items-center gap-2 cursor-pointer"><input type="radio" value="public" checked={privacy === 'public'} onChange={e => setPrivacy(e.target.value)} className="h-4 w-4 text-purple-500" /> {t('createNexus.public')}</label>
                    <label className="flex items-center gap-2 cursor-pointer"><input type="radio" value="private" checked={privacy === 'private'} onChange={e => setPrivacy(e.target.value)} className="h-4 w-4 text-purple-500" /> {t('createNexus.private')}</label>
                </div>
            </div>
            <div className="flex items-center justify-between bg-gray-800/50 p-3 rounded-lg">
                <label htmlFor="nexusColor" className="font-bold">{t('createNexus.colorLabel')}:</label>
                <input type="color" id="nexusColor" value={color} onChange={e => setColor(e.target.value)} className="w-12 h-8 rounded border-none bg-gray-700 cursor-pointer" />
            </div>
            <button type="submit" disabled={isSubmitting} className="w-full small-action-button bg-purple-600 hover:bg-purple-700 text-lg py-3 disabled:opacity-50">
                {isSubmitting ? t('createNexus.forging') : t('createNexus.forgeButton', { cost: NEXUS_CREATION_COST })}
            </button>
        </form>
    );
}

export default CreateNexusForm;